<template lang="html">
  <div class="left" :class="leftClass">
    <div class="account">
      <div class="per-img" @click="showLeft('account')">
        <avatar
          v-if="user.imgUrl===''"
         :username="user.name"
         :size="40"
        >
      </avatar>
      <img v-if="user.imgUrl!==''" :src="user.imgUrl" alt="">
      </div>
      <div class="account-cell" @click="showLeft('account')" :title="user.name">
        {{user.name}}
      </div>
      <div class="account-cell email" :title="user.email">
        {{user.email}}
      </div>
      <div class="account-cell">
        <el-button type="text" @click="logout">
          {{message.Sl107}}
        </el-button>
      </div>
    </div>
    <div class="border max-cell"></div>
    <VuePerfectScrollbar class="box" @settings="scrollSettings">
    <router-link class="left-cell send" :style="{color: transferColor}" to="./transfer" :title="message.Sl110">
      <i class="material-icons">swap_vert</i>
      <div class="font" :style="{color: color}">
        {{message.Al117}}
      </div>
    </router-link>
    <!-- <div class="border"></div> -->
    <!-- <div class="border max-cell"></div> -->
    <router-link class="left-cell inbox" to="./inbox" :class="active[0]" :title="message.Sl109">
      <i class="material-icons">
        inbox
        <el-badge v-show="completeNum > 0" :value="completeNum" class="complete-item"></el-badge>
      </i>
      <div class="font">
        {{message.Sl109}}
      </div>
    </router-link>
    <router-link class="left-cell send" to="./outbox" :title="message.Sl110">
      <i class="material-icons">send</i>
      <div class="font">
        {{message.Sl110}}
      </div>
    </router-link>
    <router-link v-if="canRetrieve" class="left-cell" :style="{color: transferColor}" to="./retrieve" :title="message.Sl233">
      <div style="margin: 12px 0;width: 24px;height: 24px;float:left">
        <i class="material-icons" style="margin:0;" v-show="!openS3ing">archive</i>
        <i class="el-icon-loading" style="font-size:24px;float:left;" v-show="openS3ing"></i>
      </div>
      <div class="font" :style="{color: color}">
        {{message.Sl233}}
      </div>
    </router-link>
    <router-link class="left-cell" to="./history" :title="message.Sl227">
      <i class="material-icons">history</i>
      <div class="font">{{message.Sl227}}</div>
    </router-link>
    <div class="border"></div>
    <div class="border max-cell"></div>
    <!-- <VuePerfectScrollbar class="box" @settings="scrollSettings"> -->
      <!-- <div class="left-cell more" @click="showLeft('flow')" :title="message.Sl197">
        <i class="material-icons">opacity</i>
        <div class="font">{{message.Sl197}}</div>
      </div> -->
      <router-link class="left-cell more"  to="./portal" :title="message.Al192">
        <i class="material-icons">exit_to_app</i>
        <div class="font" >
          {{message.Al192}}
        </div>
      </router-link>
      <router-link class="left-cell more" to="./statistics" :title="message.Sl190">
        <i class="material-icons">equalizer</i>
        <div class="font">{{message.Sl190}}</div>
      </router-link>
      <router-link class="left-cell more" to="./notification" :title="message.Sl189">
        <i class="material-icons">playlist_add_check</i>
        <div class="font">{{message.Sl189}}</div>
      </router-link>
      <!-- <div class="left-cell more" @click="toLang" v-if="show.left && browser !== 'qt'" :title="message.Sl159">
        <i class="material-icons">translate</i>
        <div class="font">{{message.Sl159}}</div>
      </div> -->
      <router-link class="left-cell more" to="./settings" :title="message.Al162">
        <i class="material-icons">settings</i>
        <div class="font" :style="{color: color}">{{message.Al162}}</div>
      </router-link>
    </VuePerfectScrollbar>
    <div class="info-main">
      <img src="../assets/config/config.server.png" alt="" style="width: 100%;">
    </div>
    <!-- <div class="info-main" :title="info.name+'('+info.version+')'">
      {{message.Sl224}}
      <div class="info">{{info.name}} ({{info.version}})</div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Avatar from 'vue-avatar'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {
    Avatar,
    VuePerfectScrollbar
  },
  computed: {
    ...mapGetters({
      user: 'user',
      show: 'show',
      app: 'app',
      transfer: 'transfer',
      notice: 'notice',
      permissions: 'permissions',
    }),
    completeNum: function () {
      var val = this.notice.newPkg
      var num = 0
      for (var i = 0; i < val.length; i++) {
        if (val[i] === localStorage.getItem('projectId')) {
          num = num + 1
        }
      }
      return num
    },
    transferColor: function (val, oldVal) {
      var color = ['#9e9e9e', '#0e181b', '#007bc5']
      if (!this.app.login) {
        color = color[0]
      } else if (this.transfer.aliveList.tasks && this.transfer.aliveList.tasks.length === 0) {
        color = color[1]
      } else {
        color = color[2]
      }
      return color
    },
    color: function () {
      var color = ['#9e9e9e', '#0e181b']
      this.app.login ? color = color[1] : color = color[0]
      return color
    }
  },
  watch: {
    'show.left': function (val) {
      if (val) {
        this.leftClass = 'max'
      } else {
        this.leftClass = 'min'
      }
    },
    'permissions': {
      deep: true,
      handler: function (newVal, oldVal) {
        this.canRetrieve = this.permissions.codes.includes('001013')
      }
    }
  },
  data () {
    return {
      message: {
        Sl109: this.$lang.ui.system.l109,
        Sl110: this.$lang.ui.system.l110,
        Sl159: this.$lang.ui.system.l159,
        Sl192: this.$lang.ui.system.l192,
        Sl107: this.$lang.ui.system.l107,
        Sl196: this.$lang.ui.system.l196,
        Sl197: this.$lang.ui.system.l197,
        Sl190: this.$lang.ui.system.l190,
        Sl181: this.$lang.ui.system.l181,
        Sl175: this.$lang.ui.system.l175,
        Sl189: this.$lang.ui.system.l189,
        Sl224: this.$lang.ui.system.l224,
        Sl227: this.$lang.ui.system.l227,
        Sl233: this.$lang.ui.system.l233,
        Al162: this.$lang.ui.app.l162,
        Al117: this.$lang.ui.app.l117,
        Al192: this.$lang.ui.app.l192
      },
      scrollSettings: {
        maxScrollbarLength: 0
      },
      info: {
        name: '',
        version: ''
      },
      active: ['', ''],
      change: '',
      leftClass: 'max',
      tabShow: false,
      browser: this._global.config.browser,
      openS3ing: false,
      canRetrieve: true
    }
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      this.$api.info(response => {
        this.info.name = response.server_info.server_name
        this.info.version = response.server_info.version
      })
    },
    showLeft (type) {
      this.tabShow = false
      this.$store.dispatch('showOther', type)
    },
    logout () {
      this.$api.logout()
    }
  }
}
</script>

<style scoped lang="css">
.left {
  z-index: 3;
  position: fixed;
  flex-grow: 0;
  order: 0;
  width: 200px;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden;
  transition: width 0.24s;
  overflow: hidden;
  background-color: #f4f4f4;
}
.logo, .left.min .account{
  display: none;
}
.logo img {
  margin-top: 9px;
  margin-left: 20px;
}
.left.max .logo {
  display: block;
  height: 58px;
  width: 100%;
}
.left.min {
  top: 58px;
  padding-top: 10px;
  width: 68px;
}
.border {
  display: none;
}
.left.min .border {
  display: block;
  height: 1px;
  width: 31px;
  margin: 5px 0;
  margin-left: 18px;
  border-top: 1px solid  rgba(117, 117, 117, 0.5);
}
.left.min .border.max-cell {
  display: none;
}
.left.max .border.max-cell {
  display: block;
  height: 1px;
  width: 100%;
  margin: 5px 0;
  border-top: 1px solid #f0f0f0;
}
.left.min .font{
  display: none;
}
.left.max {
  width: 0;
}
.left.max {
  z-index: 3;
  top: 58px;
  width: 260px;
  background: #f4f4f4;
  border-left: 1px solid #f0f0f0;
}
.left.min .title{
  display: none;
}
.left-cell {
  display: block;
  height: 48px;
  margin: 2px;
  padding-left: 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  text-align: left;
  line-height: 48px;
  overflow: hidden;
  color: #0e181b;
}
.name {
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  /*color: #09f;*/
  font-weight: 600;
  margin: 0;
  text-align: left;
  padding: 0 18px;
  padding-right: 8px;
  padding-left: 25px;
  width: 192px;
  left: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.left-cell:hover {
  background-color: #ddf0fb;
}
.left-cell.title {
  height: 25px;
  line-height: 25px;
  font-size: 12px;
}
.left-cell.more {
  color: rgba(117, 117, 117, 0.7)
}
.name:hover {
  background-color: inherit;
}
.left-cell.router-link-active {
  background-color: #ddf0fb;
}
.left-cell.router-link-active .icon {
  color: #09f;
}
.left-cell.router-link-active .font {
  font-weight: 600;
  color: #09f !important;
}
.left-cell.file {
  color: #fff;
  height: 34px;
  line-height: 34px;
  text-align: center;
  padding: 0;
  font-size: 14px;
  width: 150px;
  margin: 0 auto;
  margin-bottom: 15px;
  /*background-color: #15bea6;*/
  background-color: #d9534f;
  border: 1px solid #d43f3a;
}
.left-cell.file:hover {
  background-color: #c9302c;
}
.left-cell.change {
  height: 35px;
  line-height: 35px;
}
.material-icons {
  float: left;
  margin: 12px 0;
}
.file .icon {
  font-size: 18px;
  color: #fff;
  display: block;
  width: auto;
  float: inherit;
  overflow: inherit;
}
.file .font {
  display: block;
  text-align: center;
  float: inherit;
  color: #fff;
  padding-left: 6px;
}
.font {
  float: left;
  height: 100%;
  padding-left: 15px;
  color: #0e181b;
}

.change .icon {
  font-size: 14px;
}
.left .change-min {
  display: none;
}
.left .change-max {
  display: inline-block;
}
.operation {
  display: none;
  float: right;
  margin-right: 3px;
  cursor: pointer;
}
.user {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user:hover .operation {
  display: inline-block;
}
.account {
  width: 100%;
  text-align: left;
  padding: 10px 20px;
}
.account-cell {
  width: 198px;
  cursor: pointer;
  padding: 4px;
  color: #212121;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.account-cell:hover {
  color: #757575;
}
.account-cell.email {
  color: #757575;
  cursor: default;
}
.info-cell {
  cursor: pointer;
  width: 100%;
  padding: 6px 4px;
  border-radius: 2px;
  text-align: left;
  padding-left: 10px;
}
.info-cell:hover {
  background-color: #fff;
}
.left-cell.inbox i {
  display: block;
  position: relative;
}
.complete-item {
  position: absolute;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","\5FAE\8F6F\96C5\9ED1",Arial,sans-serif;
  top: -5px;
  left: 10px;
}
.logout {
  width: 100%;
  margin-top: 4px;
}
.per-img {
  position: relative;
  cursor: pointer;
  background-color: #fff;
  height: 40px;
  width: 40px;
  border-radius: 40px;
  overflow: hidden;
  margin: 6px 0;
}
.per-img img {
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 40px;
}
.left.max .box {
  position: absolute;
  top: 168px;
  left: 0;
  right: 0;
  bottom: 150px;
}
.info-main {
  position: absolute;
  background-color: #f4f4f4;
  border-top: 1px solid #f0f0f0;
  padding: 5px 5px 0;
  height: 150px;
  width: 100%;
  bottom: 0;
  cursor: default;
}
.info {
  width: 100%;
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 16px;
}
.left.min .info-main {
  display: none;
}
</style>
